export const INFORMATION = 'information'
export const IMAGES = 'images'
export const PLAYTIMES = 'playtimes'
export const ATTRIBUTES = 'attributes'

export const LEFT = 'left'
export const MIDDLE = 'middle'
export const RIGHT = 'right'
